import { type FC, useMemo } from 'react';
import type { RefObject } from 'react';

import SpreadsheetV16 from '@/components/UI/SpreadSheet/SpreadsheetV16';
import type { SpreadsheetV16Settings } from '@/components/UI/SpreadSheet/SpreadsheetV16.model';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTableV16';

import type { SampleTypeRow } from '@/model/SampleType.model';
import type { ValidationData } from '@/utils/sampleTypeValidation';

import { buildColumnsV16, initBulkAddSampleTypesSettingsV16 } from './BulkAddSampleTypes.utils.v16';

interface HotTableRefLike {
  hotInstance?: unknown;
}

interface BulkAddSampleTypesTableV16Props {
  data: Array<SampleTypeRow | []>;
  innerRef: RefObject<HotTableRefLike | null>;
  validationData: ValidationData | null;
  availableDetailOptions: Array<string>;
  setInvalid: (invalid: boolean) => void;
}

const BulkAddSampleTypesTableV16: FC<BulkAddSampleTypesTableV16Props> = ({
  data,
  innerRef,
  validationData,
  availableDetailOptions,
  setInvalid,
}) => {
  const columns = useMemo(
    () =>
      buildColumnsV16({
        availableDetailOptions,
        validationData,
        hotTableRef: innerRef,
      }),
    [availableDetailOptions, validationData, innerRef]
  );

  const settings = useMemo<SpreadsheetV16Settings>(() => initBulkAddSampleTypesSettingsV16(columns), [columns]);

  return (
    <div className="mv3 w-100 overflow-auto ow-spreadsheet-styles">
      <SpreadsheetV16
        className="mt3"
        testPrefix="bulk-add-sample-types-v16"
        data={data as unknown as Array<Record<string, unknown>>}
        innerRef={innerRef as RefObject<HotTableRef>}
        settings={settings}
        addCol={false}
        modalView={true}
        fillHandle={false}
        autoAddRow
        enableRowHeaderControls
        setInvalid={setInvalid}
      />
    </div>
  );
};

export default BulkAddSampleTypesTableV16;
